import { PATH_AUDIT_LOGS, PATH_ROOT } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useAuditLogsBreadcrumb = (tableName?: string) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const breadcrumbItems: BreadcrumbItem[] = [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("breadcrumb.auditLogs"), href: PATH_AUDIT_LOGS },
    ];

    if (tableName) {
      breadcrumbItems.push({
        label: t(`auditLogs.tableName.${tableName}`),
      });
    }

    return breadcrumbItems;
  }, [t, tableName]);
};
